import Action from "../../classes/Action";
import {timelineElementMap} from "../../classes/timeline";
import store, {StoreActions} from "../../state/store";
import {ITimelineParentElementPairs} from "../../interfaces/Timeline";
import {Timeline} from "../../classes/timeline/Timeline";

export default class AddMultipleTimelineElementsAction extends Action
{
	constructor(parentElementPairs: ITimelineParentElementPairs[])
	{
		//filter out any pairs where the parent already has the element as a child
		const filteredPairs = parentElementPairs.filter((pair) =>
		{
			for (const child of pair.parent.getChildren())
			{
				if (child.id === pair.element.id)	return false;
			}

			return true;
		});

		super(
			[filteredPairs],
			[filteredPairs],
			"Recorded changes to Timeline",
			[filteredPairs]
		);
	}

	do(parentElementPairs: ITimelineParentElementPairs[]) : void
	{
		const timelineId = store.getState().timelineModule.editorData.timelineId;
		if (!timelineId) 
		{
			throw new Error("Timeline ID is undefined");
		}

		const timeline = timelineElementMap.get(timelineId) as Timeline;
		timeline.resetAnimations();
		parentElementPairs.forEach((parentElementPair) =>
		{
			parentElementPair.parent.getChildren().push(parentElementPair.element);
			parentElementPair.element.onAdded();
		});
		timeline.update();
		store.dispatch(StoreActions.timeline.updateEditorUI());
	}

	undo(parentElementPairs: ITimelineParentElementPairs[]) : void
	{
		const timelineId = store.getState().timelineModule.editorData.timelineId;
		if (!timelineId)
		{
			throw new Error("Timeline ID is undefined");
		}

		const timeline = timelineElementMap.get(timelineId) as Timeline;
		timeline.resetAnimations();
		parentElementPairs.forEach((parentElementPair) =>
		{
			parentElementPair.parent.setChildren(parentElementPair.parent.getChildren().filter((child) => child.id !== parentElementPair.element.id));
			parentElementPair.element.onDelete();
		});
		timeline.update();
		store.dispatch(StoreActions.timeline.updateEditorUI());
	}

	verify(parentElementPairs: ITimelineParentElementPairs[]) : boolean
	{
		return parentElementPairs.length > 0;
	}
}
